import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DinoRunnerGame from "./DinoRunnerGame";
import "./WaitingGameOffer.scss";

const WAITING_GAME_DELAY_MS = 5000;

interface Props {
  isWaiting: boolean;
  promptTitle?: string;
  promptLead?: string;
  promptQuestion?: string;
  gameNote?: string;
  closeButtonLabel?: string;
}

export default function WaitingGameOffer({
  isWaiting,
  promptTitle = "¿Todavía esperando?",
  promptLead = "La creación de contactos está tardando un poco más de lo habitual.",
  promptQuestion = "¿Quieres jugar al clásico del dinosaurio mientras seguimos trabajando en segundo plano?",
  gameNote = "El proceso sigue en segundo plano. Puedes cerrar el juego cuando quieras.",
  closeButtonLabel = "Volver a los leads",
}: Props) {
  const [showPrompt, setShowPrompt] = useState(false);
  const [showGame, setShowGame] = useState(false);
  const [promptDismissed, setPromptDismissed] = useState(false);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (!isWaiting) {
      setShowPrompt(false);
      setShowGame(false);
      setPromptDismissed(false);
      return undefined;
    }

    timerRef.current = window.setTimeout(() => {
      if (!promptDismissed) {
        setShowPrompt(true);
      }
    }, WAITING_GAME_DELAY_MS);

    return () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isWaiting, promptDismissed]);

  const handleAcceptGame = () => {
    setShowPrompt(false);
    setShowGame(true);
  };

  const handleDeclineGame = () => {
    setShowPrompt(false);
    setPromptDismissed(true);
  };

  const handleCloseGame = () => {
    setShowGame(false);
  };

  return (
    <>
      <Modal
        isOpen={showPrompt}
        toggle={handleDeclineGame}
        centered
        className="waiting-game-offer__prompt-modal"
      >
        <ModalHeader toggle={handleDeclineGame}>{promptTitle}</ModalHeader>
        <ModalBody>
          <p className="mb-2">{promptLead}</p>
          <p className="mb-0">{promptQuestion}</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={handleDeclineGame}>
            No, gracias
          </Button>
          <Button color="primary" onClick={handleAcceptGame}>
            ¡Sí, jugar!
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={showGame}
        toggle={handleCloseGame}
        size="lg"
        centered
        className="waiting-game-offer__game-modal"
      >
        <ModalHeader toggle={handleCloseGame}>
          Dino Wembii Runner
        </ModalHeader>
        <ModalBody>
          <p className="waiting-game-offer__game-note">{gameNote}</p>
          <DinoRunnerGame />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCloseGame}>
            {closeButtonLabel}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
